import React, { useState, useMemo, useRef, memo } from 'react';
import { GetAllUsers, DeleteUser } from "../../api/endpoints";
import AddEditUser from './CUUser';
import ReportContent from '../../component/tableDrawer/reportContent';
import ReportHeader from '../../component/tableDrawer/reportHeader';
import ReportSearch from '../../component/tableDrawer/reportSearch';
import DeleteBtn from '../../component/tableDrawer/Tables/Components/TableActions/DeleteBtn';
import EditBtn from '../../component/tableDrawer/Tables/Components/TableActions/EditBtn';


const UsersC = () => {
    const [UserID, setUserID] = useState(null);

    const insertModal = useRef("insertUserModal")
    const updateModal = useRef("UpdateUserModal")

    const columns = useMemo(
        () => [

            {
                Header: 'Name',
                accessor: 'name',
                canSearch: true

            },
            {
                Header: 'Email',
                accessor: 'email',
                canSearch: true
            },
            {
                Header: 'Role',
                accessor: 'roleName'
            },
            {
                id: 'actions',
                Cell: ({ row: { original } }) => {
                    return (
                        <>
                            <EditBtn onApply={updateUser} id={original?.id} />
                            <DeleteBtn api={DeleteUser} id={original.id} />
                        </>
                    )
                }
            }
        ], []
    )

    const updateUser = (userID) => {
        setUserID(userID);
        updateModal.current.click()
    }

    const openInsertModal = () => {
        insertModal.current.click()
    }

    return (
        <>
            <AddEditUser modalID={insertModal} />
            <AddEditUser rowId={UserID} modalID={updateModal} />
            <ReportContent tableAPI={GetAllUsers} columns={columns}>
                <ReportHeader ApplyAction={openInsertModal} ActionName={"adit-user"}>
                    <ReportSearch />
                </ReportHeader>
            </ReportContent>

        </>
    );
}

export default memo(UsersC);